var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("input", {
        ref: "upload",
        attrs: {
          type: "file",
          accept: _vm.allowed_files,
          hidden: ""
        },
        on: {
          change: _vm.setFile
        }
      }),
      _c(
        "v-tooltip",
        {
          attrs: {
            bottom: ""
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function fn(_ref) {
                var on = _ref.on
                return [
                  _c(
                    "gg-btn",
                    _vm._g(
                      {
                        attrs: {
                          secondary: ""
                        },
                        on: {
                          click: _vm.openUploadInput
                        }
                      },
                      on
                    ),
                    [_c("span", [_vm._v("Add file")])]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("span", [
            _vm._v("Allowed types are " + _vm._s(_vm.allowed_files_human))
          ])
        ]
      ),
      _vm.files.length
        ? _c(
            "div",
            {
              staticClass: "pt-4"
            },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "v-chip",
                {
                  key: index,
                  staticClass: "mr-2",
                  attrs: {
                    close: "",
                    label: ""
                  },
                  on: {
                    "click:close": function clickClose($event) {
                      return _vm.deleteFile(file)
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        left: ""
                      }
                    },
                    [_vm._v(" mdi-file ")]
                  ),
                  _vm._v(" " + _vm._s(file.name) + " ")
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }